import React, { useEffect, useState } from "react";
import Slidere from "./Slider";
import Dealsoftheday from "./Dealsoftheday";
import Shearchbar from "./Shearchbar";
import Navbar from "./Navbar";
import Manubar from "./Manubar";
import secureLocalStorage from "react-secure-storage";
import axios from "axios";
import baseurl from "./Baseurl";
import "./header.css";
import Freshfruit from "./Freshfruit";
import BestLeasing from "./BestLeasing";
import { Link } from "react-router-dom";
import ImageSlider from "./ImageSlider";

const Header = () => {
 
  return (
    <>
      <div className="modal fade offcanvas-modal" id="exampleModal">
        <div className="modal-dialog offcanvas-dialog">
          <div className="modal-content">
            <Manubar />
          </div>
        </div>
      </div>
      <header>
        <Shearchbar />
        <Navbar />
      </header>
      <Slidere />
      <div>
        <Freshfruit />
        <ImageSlider />
        <Dealsoftheday />
        <BestLeasing />
      </div>
    </>
  );
};

export default Header;
